import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6492515c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub-header" }, "Attach a message!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GemHeader = _resolveComponent("GemHeader")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_GemHeader, {
      title: "Drop a gem",
      color: _ctx.color
    }, null, 8, ["color"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_Field, {
        modelValue: _ctx.message,
        class: "message-input",
        placeholder: "Enter your message",
        type: "textarea",
        rows: "5",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('set-message-event', $event.target.value)))
      }, null, 8, ["modelValue"])
    ])
  ]))
}